export const FORMAT = {
  HM: "HH:mm",
  DATE: "YYYY-MM-DD",
  TIME: "HH:mm",
  DATE_HM: "YYYY-MM-DD, HH:mm",
  DATE_HMS: "YYYY-MM-DD, HH:mm:ss",
  MONTH: "YYYY-MM",
  MMM_DD_YYYY: "MMM DD, YYYY",
  MM_DD_YYYY: "MM.DD.YYYY",
  MMMM_YYYY: "MMMM, YYYY",
  MMDDYYYY: "MM.DD.YYYY HH:mm",
  DDMMYYYY: "DD.MM.YYYY HH:mm",
  DD_MM_YYYY: "DD.MM.YYYY",
  MMM_DD: "MMM DD",
  YEAR: "YYYY"
};
